import { ChannelTypes } from '../../actions/content'
import { DateUtils } from '../../utils'
import initialState from './initialState'
import { formatMedia } from './media/helpers'

function formatRawDeviceInfo({ last_contact, last_download, layer_extra, ...device }) {
    return {
        ...device,
        isOnline: false,
        last_contact: last_contact && DateUtils.UTCDateToTimestamp(last_contact),
        last_download: last_download && DateUtils.UTCDateToTimestamp(last_download),
        layer_extra: JSON.parse(layer_extra || '{}'),
    }
}

export default (state, { type, payload = {}, meta = {} }) => {
    switch (type) {
        case ChannelTypes.CREATE_CHANNEL_CP_REQUEST:
        case ChannelTypes.DESTROY_CHANNEL_REQUEST:
        case ChannelTypes.FETCH_CHANNELS_REQUEST:
        case ChannelTypes.UPDATE_CHANNEL_REQUEST:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    channels: true,
                },
            }
        case ChannelTypes.DESELECT_CHANNEL: {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    channels: initialState.selected.channels,
                },
            }
        }
        case ChannelTypes.FETCH_CHANNEL_REQUEST:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    channelSingle: true,
                },
            }
        case ChannelTypes.FETCH_CHANNEL_DEVICES_REQUEST:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    channelDevices: true,
                },
            }
        case ChannelTypes.FETCH_CHANNELS_SUCCESS:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    channels: false,
                },
                channels: meta.noFirstPage ? [...state.channels, ...payload.data] : payload.data,
                pagination: {
                    ...state.pagination,
                    channels: {
                        currentPage: payload.current_page,
                        perPage: payload.per_page,
                        total: payload.total,
                        from: payload.from,
                        to: payload.to,
                    },
                },
            }
        case ChannelTypes.FETCH_CHANNEL_SUCCESS: {
            const media = payload.media.map(formatMedia)

            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    channelSingle: false,
                },
                selected: {
                    ...state.selected,
                    channels: {
                        ...payload,
                        media,
                    },
                },
            }
        }
        case ChannelTypes.UPDATE_CHANNEL_SUCCESS:
            const media = payload.media.map(formatMedia)
            if (meta.withArray)
                return {
                    ...state,
                    isWorking: {
                        ...state.isWorking,
                        channels: false,
                    },
                    selected: {
                        ...state.selected,
                        channels: {
                            ...payload,
                            media,
                        },
                    },
                }
            const indexUpdated = state.channels.findIndex((channel) => channel.id === meta.id)
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    channels: false,
                },
                channels: [...state.channels.slice(0, indexUpdated), payload, ...state.channels.slice(indexUpdated + 1, state.channels.length)],
            }
        case ChannelTypes.FETCH_CHANNEL_DEVICES_SUCCESS:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    channelDevices: false,
                },
                selected: {
                    ...state.selected,
                    channels: {
                        ...(state.selected.channels || {}),
                        devices: payload.map((device) => formatRawDeviceInfo(device)),
                    },
                },
            }
        case ChannelTypes.CREATE_CHANNEL_CP_SUCCESS:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    channels: false,
                },
                contentPushContent: {
                    ...state.contentPushContent,
                    channel: {
                        ...payload,
                    },
                },
            }
        case ChannelTypes.CHANGE_CHANNELS:
            return {
                ...state,
                channels: payload,
            }
        case ChannelTypes.CHANGE_SELECTED_CHANNEL:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    channels: {
                        ...payload,
                    },
                },
            }
        case ChannelTypes.DESTROY_CHANNEL_FAILURE:
        case ChannelTypes.DESTROY_CHANNEL_SUCCESS:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    channels: false,
                },
                contentPushContent: {
                    ...state.contentPushContent,
                    channel: null,
                },
            }
        case ChannelTypes.DELETE_CHANNEL_SUCCESS:
            const {
                selected: { channels: selectedChannel },
            } = state
            const index = state.channels.findIndex((channel) => channel.id === meta.id)
            let newSelectedChannel = selectedChannel
            if (selectedChannel && state.channels[index] && state.channels[index].id === selectedChannel.id) {
                newSelectedChannel = {}
            }
            return {
                ...state,
                selected: {
                    ...state.selected,
                    channels: newSelectedChannel,
                },
                channels: [...state.channels.slice(0, index), ...state.channels.slice(index + 1, state.channels.length)],
            }
        case ChannelTypes.DETACH_MEDIA_CHANNEL_SUCCESS: 
            return {
                ...state,
                selected: {
                    ...state.selected,
                    channels: { ...state.selected.channels, media: state.selected.channels?.media?.filter((item) => item.id !== meta.id) },
                },
            }
        default:
            return null
    }
}

export function getSelectedChannel(state) {
    return state.content.selected.channels
}
